//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Start
import { memo, useCallback, useEffect, useState } from 'react';
import LoginQR from './LoginQR';
import { Row, Col, Container, NavDropdown } from 'react-bootstrap';
import { BzButton, BzInputText, BzTabsContainer, BzTabsContent, BzModal, BzModalBody, BzModalTitle, BzModalHeader, BzModalFooter } from '../../components';
import { API_RESPONSE_STATUS, LOGIN_CONSTANTS, API_ERRORS, LOCAL_STORAGE_KEYS } from '../../utils/global_variables';
import { useDispatch } from 'react-redux';
import { getDecryptLocalStorage, getStorageWithMultiTabCheck, handleKeyDownOnDiv, removeStorageWithMultiTabCheck, setStorageWithMultiTabCheck } from '../../utils/global_functions';
import DeleteProfileConfirmationModal from '../UserProfile/DeleteProfileConfirmationModal';
import SuccessModal from '../UserProfile/SuccessModal';
import { handleModal } from '../../redux/actions/modals';

const MpinBody = ({ usersModal, setUsersModal, handleSusequentPasswordLogin, activeProfile, setActiveProfile,
    handleMpinChange, handleMpinKeyUp, mpin, showPassword, objLoginSession, handleUserIdPasswordOnChange,
    setShowPassword, route, handleTakeMeToSelect, userDetails, setUserDetails, objUserCredentials, handleUseAnotherAccount, handleUserChoice, inputRef, passwordRef, bSubLoginButton, user, setUser, handleMpinPassword,
     }) => {
    const isPasswordChanged = getDecryptLocalStorage('IS_PASSWORD_CHANGED');
    const previousLoginTab = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.LOGIN_TAB) || 'mpin';
    // const brokerInformation = useSelector(state => state?.appInfo?.brokerInformation);
    const dispatch = useDispatch();
    // const [bQRLogin, setbQRLogin] = useState(false)

    const [userSelected, setUserSelected] = useState();


    const handleFavorite = (e) => {
        const newArray = userDetails.map((details) => {
            if (details.userId === e.userId) {
                return { ...details, bIsDefault: !details['bIsDefault'] };
            } else {
                return { ...details, bIsDefault: false };
            }
        });
        setUserDetails(newArray);
    };


    useEffect(() => {
        for (let i = 0; i < userDetails.length; i++) {
            let objStorageUserDetails = {};
            const strStorageUserDetails = getStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userDetails[i].userId}`);
            if (strStorageUserDetails) {
                objStorageUserDetails = JSON.parse(strStorageUserDetails);
            } else { }
            objStorageUserDetails = { ...userDetails[i], ...objStorageUserDetails };
            setStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${userDetails[i].userId}`, JSON.stringify(userDetails[i]));
        }
    }, [userDetails]);


    const handleDeleteUser = useCallback((user) => {
        if (userDetails && user) {
            dispatch(handleModal([{ "DELETE_PROFILE_CONFIRMATION_MODAL": false }]));
            removeStorageWithMultiTabCheck(`${LOCAL_STORAGE_KEYS.USER_DETAILS}_${user.userId}`);
            let users = userDetails.filter((each) => each.userId !== user.userId);
            setUserDetails(users);
            if (activeProfile.userId === user.userId) {
                if (users) {
                    if (users.length > 2) {
                        setActiveProfile(users[users.length - 1]);
                        setUser(users[users.length - 1]);
                    } else if (users.length <= 2) {
                        setActiveProfile(users[0]);
                        setUser(users[0]);
                    }
                } else {
                    setActiveProfile(users[0]);
                    setUser(users[0]);
                }
            }
            setUserSelected();
            dispatch(handleModal([{ 'USER_DELETE_SUCCESS_MODAL': true }]));
            setTimeout(() => {
                dispatch(handleModal([{ 'USER_DELETE_SUCCESS_MODAL': false }]));
            }, 1000);
        } else { }
    }, [localStorage, userDetails, activeProfile, dispatch]);


    const handleConfirmDelete = (user) => {
        setUserSelected(user);
        dispatch(handleModal([{ "DELETE_PROFILE_CONFIRMATION_MODAL": true }]));
    };



    // onClick={(e) => handleDeleteUser(each)}

    return (
        <>
            <DeleteProfileConfirmationModal user={userSelected} onDeleteProfileConfirmation={handleDeleteUser} />
            <SuccessModal />
            <Container fluid className='p-0'>
                <BzTabsContainer>
                    <BzTabsContent showDefault isActive={!isPasswordChanged && previousLoginTab === 'mpin'} tabKey='mpin'>
                        <div className='login-content p-1'>
                            <Row className='g-0 mb-2'>
                                <Col>
                                    <div className='font-medium font-size2 color-text'>Enter M-Pin</div>
                                </Col>
                            </Row>
                            <div className='mb-3'>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div className='mpin-wrap'>
                                            {
                                                mpin.map((data, index) => {
                                                    return (
                                                        <BzInputText
                                                            data-testid={`login-mpin-${index + 1}th-digit-input`}
                                                            type="password"
                                                            name="mpin"
                                                            maxLength="1"
                                                            className={`font-regular ${objLoginSession?.status === API_RESPONSE_STATUS.SUCCESS ? 'success' : (objLoginSession?.status === API_RESPONSE_STATUS.ERROR ? 'error' : '')}`}
                                                            key={index}
                                                            value={data}
                                                            onChange={e => handleMpinChange(e.target, index)}
                                                            onKeyUp={e => handleMpinKeyUp(e, index)}
                                                            onFocus={e => e.target.select()}
                                                            ref={index === 0 ? inputRef : null}
                                                        />
                                                    );
                                                })
                                            }
                                        </div>
                                        {/* {objLoginSession?.status === API_RESPONSE_STATUS.SUCCESS ? <div className='icon-20 icon-checktick icon-positive'></div> : ''}
                                        {objLoginSession?.status === API_RESPONSE_STATUS.ERROR ? <div className='icon-20 icon-close-fill icon-negative'></div> : ''} */}
                                    </Col>
                                </Row>
                                {objLoginSession?.status === API_RESPONSE_STATUS.ERROR &&
                                    <Row className='g-0 mt-2'>
                                        <Col className='d-flex justify-content-start'>
                                            <div className='error-msg text-wrap'>{objLoginSession.message}</div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                            <Row className='g-0 align-items-center'>
                                <Col>
                                    <div className='font-regular font-size3 color-subtext float-start'>Take Me To</div>
                                    <NavDropdown data-testid='login-mpin-landing-dropdown' className='font-medium font-size3 color-primary text-capitalize ms-2 float-start' title={route} onSelect={handleTakeMeToSelect}>
                                        <NavDropdown.Item size="sm" eventKey="dashboard" data-testid="login-mpin-landing-dropdown-dashboard-item">Dashboard</NavDropdown.Item>
                                        <NavDropdown.Item size="sm" eventKey="watchlist" data-testid="login-mpin-landing-dropdown-watchlist-item">Watchlist</NavDropdown.Item>
                                        <NavDropdown.Item size="sm" eventKey="portfolio" data-testid="login-mpin-landing-dropdown-portfolio-item">Portfolio</NavDropdown.Item>
                                        <NavDropdown.Item size="sm" eventKey="orders" data-testid="login-mpin-landing-dropdown-orders-item">Orders</NavDropdown.Item>
                                    </NavDropdown>
                                </Col>
                                <Col className='d-flex justify-content-end'>
                                    <a onClick={() => handleMpinPassword('mpin')} className='font-medium font-size2 color-link focus' href='#' onKeyDown={handleKeyDownOnDiv} name='forgot_mpin' data-testid="forgot-mpin-link">Forgot M-Pin?</a>
                                </Col>
                            </Row>
                        </div>
                        {/* <Row className='g-0 mt-3 ps-1'>
                            <Col>
                                <div className='font-medium font-size1 color-subtext'>
                                    {brokerInformation?.length &&
                                        Object.entries(brokerInformation[0]).map(([key, item], i) => (
                                            <span key={i}>
                                                {item.Exchange} - <span className="font-regular">Member ID: {item.MemberID}</span> |
                                            </span>
                                        ))
                                    }
                                </div>
                            </Col>
                        </Row> */}
                    </BzTabsContent>
                    <BzTabsContent tabKey='pswd' showDefault isActive={!!isPasswordChanged || previousLoginTab === 'pswd'}>
                        <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                            <div className='login-content p-1'>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className='font-medium font-size2 color-text'>Enter Password</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-2'>
                                    <Col>
                                        <div className={`input-group position-relative ${objLoginSession?.status === API_RESPONSE_STATUS.ERROR ? 'error' : ''}`}>
                                            <BzInputText data-testid='relogin-password-input' ref={passwordRef} name='user_password' value={objUserCredentials.user_password} type={`${showPassword ? 'text' : 'password'}`} placeholder='Password' maxLength={LOGIN_CONSTANTS.LOGIN_PASSWORD_MAX_LENGTH} onChange={(e) => handleUserIdPasswordOnChange(e)} className='font-regular font-size2 pe-5' />
                                            <div data-testid={`${showPassword ? 'relogin-password-visible-icon' : 'relogin-password-hidden-icon'}`} onClick={() => { setShowPassword(curr => !curr); }} className={`icon-20 ${showPassword ? 'icon-eye' : 'icon-eyeslash'} icon-grey login-icon-position`}></div>
                                        </div>
                                    </Col>
                                </Row>
                                {(objLoginSession && objLoginSession?.status === API_RESPONSE_STATUS.ERROR && objLoginSession?.errors !== API_ERRORS.ECODE_PWD_EXPIRED) &&
                                    <Row className='g-0 mb-2'>
                                        <Col>
                                            <div data-testid='relogin-invalid-or-wrong-password-error' className='error-msg'>{objLoginSession.message}</div>
                                        </Col>
                                    </Row>
                                }
                                <Row className='g-0 mb-3'>
                                    <Col>
                                        <BzButton data-testid='relogin-password-verify-button' type='submit' className='btn btn-md btn-block btn-primary' onClick={handleSusequentPasswordLogin} disabled={!bSubLoginButton}>Verify</BzButton>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col>
                                        <div className='font-regular font-size3 color-subtext float-start'>Take Me To</div>
                                        <NavDropdown data-testid='relogin-password-landing-dropdown' className='font-medium font-size3 color-primary text-capitalize ms-2 float-start' title={route} onSelect={handleTakeMeToSelect}>
                                            <NavDropdown.Item data-testid='relogin-password-landing-dropdown-dashboard-item' size="sm" eventKey="dashboard">Dashboard</NavDropdown.Item>
                                            <NavDropdown.Item data-testid='relogin-password-landing-dropdown-watchlist-item' size="sm" eventKey="watchlist">Watchlist</NavDropdown.Item>
                                            <NavDropdown.Item data-testid='relogin-password-landing-dropdown-portfolio-item' size="sm" eventKey="portfolio">Portfolio</NavDropdown.Item>
                                            <NavDropdown.Item data-testid='relogin-password-landing-dropdown-orders-item' size="sm" eventKey="orders">Orders</NavDropdown.Item>
                                        </NavDropdown>
                                    </Col>
                                    <Col className='d-flex justify-content-end align-self-center'>
                                        <a data-testid='relogin-forgot-password-link' className='font-medium font-size2 color-link focus' name='forgot_password' href='#' onKeyDown={handleKeyDownOnDiv} onClick={() => handleMpinPassword('password')} >Forgot Password?</a>
                                    </Col>
                                </Row>
                            </div>
                        </form>
                        {/* <Row className='g-0 mt-3 ps-1'>
                            <Col>
                                <div className='font-medium font-size1 color-subtext'>
                                    {brokerInformation?.length &&
                                        Object.entries(brokerInformation[0]).map(([key, item], i) => (
                                            <span key={i}>
                                                {item.Exchange} - <span className="font-regular">Member ID: {item.MemberID}</span> |
                                            </span>
                                        ))
                                    }
                                </div>
                            </Col>
                        </Row> */}
                    </BzTabsContent>
                    <BzTabsContent tabKey='qr_code' showDefault isActive={!!isPasswordChanged || previousLoginTab === 'qr_code'} mountOnEnter>
                        <LoginQR />
                    </BzTabsContent>
                </BzTabsContainer>
            </Container>

            <BzModal centered show={usersModal} onHide={setUsersModal} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-self-center'>
                                <BzModalTitle data-testid='switch_account_header' className='font-medium font-size4 color-text'>Switch Account</BzModalTitle>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={() => setUsersModal(false)}>&nbsp;</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        {userDetails.map((each) => (
                            <Row key={each.userId} className='g-0 my-3'>
                                <Col md={8} className='d-flex justify-content-start align-items-center'>
                                    <div className='form-check'>
                                        <input className='form-check-input me-2 mt-1' type="radio" name="profile" id={each?.userId} onChange={() => setUser(each)} checked={user?.userId === each?.userId} />
                                        <label className='font-medium font-size4 color-text' htmlFor={each?.userId}>{each?.userName}</label>      
                                        <div className='font-medium font-size3 color-subtext'>User ID: <span className='font-regular color-text'>{each?.loginByAliasId ? each?.aliasId : each?.userId}</span></div>
                                    </div>
                                </Col>
                                {userDetails.length >= 2 ?
                                    <Col md={4} className='d-flex justify-content-center align-items-center cursor-pointer'>
                                        <Container fluid className='p-0'>
                                            <Row className='g-0'>
                                                <Col className='me-3'>
                                                    <div className='d-flex  justify-content-end align-items-center' onClick={handleFavorite.bind(this, each)}>
                                                        <div className='font-medium font-size3 color-primary text-truncate me-2' >{each?.bIsDefault ? 'Default' : 'Set Default'}</div>
                                                        {each.bIsDefault ? <div className='icon-16 icon-checktick icon-primary'></div> : ''}
                                                    </div>
                                                </Col>
                                                <Col md={1}>
                                                    <div data-testid="delete-user" className='d-flex justify-content-end align-items-center icon-16 icon-delete icon-dark' onClick={handleConfirmDelete.bind(this, each)}></div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>

                                    : null}

                            </Row>
                        ))}

                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0'>
                        <Row className='g-0 align-items-center'>
                            <Col md={6} className='d-flex justify-content-strat align-items-center'>
                                <div className='icon-20 icon-profile background-textual-link-withicon me-2' onClick={() => setUsersModal(false)}>&nbsp;</div>
                                <div className='font-medium font-size4 color-textual-link-withicon cursor-pointer' onClick={handleUseAnotherAccount}>Add another account</div>
                            </Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                <BzButton data-testid='choose_accnt_and_continue' className='btn btn-md btn-primary' onClick={handleUserChoice}>Choose &amp; Continue</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </>
    );
};

export default memo(MpinBody);

//Mahesh S : 13-02-2023 : BT-97226 -  Breeze - Subsequent Login - Ends